import { Fragment, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardSubtitle,
  CardTitle,
  Col,
  Container, Row
} from "reactstrap";
import { accessRole } from "../../../helpers/access_role";
import TableComponent from "./Components/TableComponent";
import "./style.scss";

const IndexView = (props) => {
  const activeRef = useRef();
  const inactiveRef = useRef();

  const [agendasCount, setAgendasCount] = useState(0);

  const reloadInactiveRef = () => inactiveRef.current.setTokenAPI();
  
  function setCountCb(res, type) {
      setAgendasCount(res);
  }
  
  const renderTableView = () => {
    return (
      <>
        <TableComponent
          cb={setCountCb}
          ref={activeRef}
          handleInactiveSuccess={reloadInactiveRef}
        />
      </>
    );
  };


  const renderView = () => {
    return renderTableView();
  };

  return (
    <Fragment>
      <Container fluid>
        <Row>
          <Col className="col-12">
            <Card>
              <CardBody>
                <div className="float-end">
                  <div className="d-flex" style={{ columnGap: "1rem" }}>
                    {accessRole("create") ? (
                      <Link to="layanan_portal.html?create">
                        <Button color="primary">Buat Layanan Portal</Button>
                      </Link>
                    ) : null}
                  </div>
                </div>
                <CardTitle>Layanan Portal</CardTitle>
                <CardSubtitle className="mb-3">Data - data Layanan Portal</CardSubtitle>
                <hr />
                {renderView()}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default IndexView;
